import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Multiple from '@/pages/Multiple'
import Search from '@/pages/Search'
import SearchDetail from '@/pages/SearchDetail'
import Dawan from '@/pages/Dawan'
import Intelligent from '@/pages/Intelligent'
import DoClearance from '@/pages/DoClearance'
import DoClearanceDetail from '@/pages/DoClearanceDetail'
import DoInvest from '@/pages/DoInvest'
import DoWork from '@/pages/DoWork'
import DoWorkDetail from '@/pages/DoWorkDetail'
import Explain from '@/pages/Explain'
import SearchDetailBorn1 from '@/pages/SearchDetailBorn1'
import SearchDetailBorn2 from '@/pages/SearchDetailBorn2'
import SearchDetailBorn3 from '@/pages/SearchDetailBorn3'
import SearchDetailBorn4 from '@/pages/SearchDetailBorn4'
import SearchDetailStudy1 from '@/pages/SearchDetailStudy1'
import SearchDetailWork1 from '@/pages/SearchDetailWork1'
import SearchDetailWork2 from '@/pages/SearchDetailWork2'
import SearchDetailWork3 from '@/pages/SearchDetailWork3'
import SearchDetailWork4 from '@/pages/SearchDetailWork4'
import SearchDetailWork5 from '@/pages/SearchDetailWork5'
import SearchDetailHouse1 from '@/pages/SearchDetailHouse1'
import SearchDetailHouse2 from '@/pages/SearchDetailHouse2'
import SearchDetailHouse3 from '@/pages/SearchDetailHouse3'
import SearchDetailHouse4 from '@/pages/SearchDetailHouse4'
import SearchDetailHouse5 from '@/pages/SearchDetailHouse5'
import SearchDetailHouse6 from '@/pages/SearchDetailHouse6'
import SearchDetailHouse7 from '@/pages/SearchDetailHouse7'
import SearchDetailMarriage1 from '@/pages/SearchDetailMarriage1'
import SearchDetailCredit2 from '@/pages/SearchDetailCredit2'
import SearchDetailCredit3 from '@/pages/SearchDetailCredit3'
import SearchDetailCredit4 from '@/pages/SearchDetailCredit4'
import SearchDetailCredit5 from '@/pages/SearchDetailCredit5'
import SearchDetailCredit6 from '@/pages/SearchDetailCredit6'
import SearchDetailCredit7 from '@/pages/SearchDetailCredit7'
import SearchDetailCredit8 from '@/pages/SearchDetailCredit8'
import SearchDetailCredit9 from '@/pages/SearchDetailCredit9'
import SearchDetailCredit10 from '@/pages/SearchDetailCredit10'
import SearchDetailCredit11 from '@/pages/SearchDetailCredit11'
import SearchDetailCredit12 from '@/pages/SearchDetailCredit12'
import SearchDetailCredit13 from '@/pages/SearchDetailCredit13'
import SearchDetailCredit14 from '@/pages/SearchDetailCredit14'
import SearchDetailCredit15 from '@/pages/SearchDetailCredit15'
import SearchDetailCredit16 from '@/pages/SearchDetailCredit16'
import SearchDetailCredit17 from '@/pages/SearchDetailCredit17'
import SearchDetailCredit18 from '@/pages/SearchDetailCredit18'
import SearchDetailCredit19 from '@/pages/SearchDetailCredit19'
import SearchDetailCredit20 from '@/pages/SearchDetailCredit20'
import SearchDetailCredit21 from '@/pages/SearchDetailCredit21'
import SearchDetailCredit22 from '@/pages/SearchDetailCredit22'
import SearchDetailRetirement1 from '@/pages/SearchDetailRetirement1'
import SearchDetailRetirement2 from '@/pages/SearchDetailRetirement2'
import SearchDetailRetirement3 from '@/pages/SearchDetailRetirement3'
import SearchDetailRetirement4 from '@/pages/SearchDetailRetirement4'
import SearchDetailDeath1 from '@/pages/SearchDetailDeath1'
import SearchDetailEnterprise1 from '@/pages/SearchDetailEnterprise1'
import SearchDetailEnterprise2 from '@/pages/SearchDetailEnterprise2'
import SearchDetailEnterprise3 from '@/pages/SearchDetailEnterprise3'
import SearchDetailEnterprise4 from '@/pages/SearchDetailEnterprise4'
import SearchDetailEnterprise5 from '@/pages/SearchDetailEnterprise5'
import SearchDetailRecruit2 from '@/pages/SearchDetailRecruit2'
import SearchDetailLogout3 from '@/pages/SearchDetailLogout3'
import SearchDetailOperate1 from '@/pages/SearchDetailOperate1'
import SearchDetailOperate2 from '@/pages/SearchDetailOperate2'
import SearchDetailOperate3 from '@/pages/SearchDetailOperate3'
import SearchDetailOperate4 from '@/pages/SearchDetailOperate4'
import SearchDetailOperate5 from '@/pages/SearchDetailOperate5'
import SearchDetailOperate6 from '@/pages/SearchDetailOperate6'
import SearchDetailOperate7 from '@/pages/SearchDetailOperate7'
import SearchDetailOperate8 from '@/pages/SearchDetailOperate8'
import SearchDetailOperate9 from '@/pages/SearchDetailOperate9'
import SearchDetailOperate10 from '@/pages/SearchDetailOperate10'
import SearchDetailOperate11 from '@/pages/SearchDetailOperate11'
import SearchDetailOperate12 from '@/pages/SearchDetailOperate12'
import SearchDetailOperate13 from '@/pages/SearchDetailOperate13'
import SearchDetailOperate14 from '@/pages/SearchDetailOperate14'
import SearchDetailOperate15 from '@/pages/SearchDetailOperate15'
import SearchDetailOperate16 from '@/pages/SearchDetailOperate16'
import SearchDetailOperate17 from '@/pages/SearchDetailOperate17'
import SearchDetailOperate18 from '@/pages/SearchDetailOperate18'
import SearchDetailOperate19 from '@/pages/SearchDetailOperate19'
import SearchDetailOperate20 from '@/pages/SearchDetailOperate20'
import SearchDetailOperate21 from '@/pages/SearchDetailOperate21'
import SearchDetailOperate22 from '@/pages/SearchDetailOperate22'
import SearchDetailOperate23 from '@/pages/SearchDetailOperate23'
import SearchDetailOperate24 from '@/pages/SearchDetailOperate24'
import SearchDetailOperate25 from '@/pages/SearchDetailOperate25'
import SearchDetailRecruit1 from '@/pages/SearchDetailRecruit1'
import SearchDetailPay1 from '@/pages/SearchDetailPay1'
import SearchDetailLogout1 from '@/pages/SearchDetailLogout1'
import SearchDetailEnterprise6 from '@/pages/SearchDetailEnterprise6'
import SearchDetailEnterprise7 from '@/pages/SearchDetailEnterprise7'
import SearchDetailLogout4 from '@/pages/SearchDetailLogout4'
import SearchDetailEnterprise8 from '@/pages/SearchDetailEnterprise8'
import SearchDetailEnterprise9 from '@/pages/SearchDetailEnterprise9'
import SearchDetailEnterprise10 from '@/pages/SearchDetailEnterprise10'
import SearchDetailEnterprise11 from '@/pages/SearchDetailEnterprise11'
import SearchDetailEnterprise12 from '@/pages/SearchDetailEnterprise12'
import SearchDetailEnterprise13 from '@/pages/SearchDetailEnterprise13'
import SearchDetailEnterprise14 from '@/pages/SearchDetailEnterprise14'
import SearchDetailEnterprise15 from '@/pages/SearchDetailEnterprise15'
import SearchDetailEnterprise16 from '@/pages/SearchDetailEnterprise16'
import SearchDetailEnterprise17 from '@/pages/SearchDetailEnterprise17'
import SearchDetailLogout5 from '@/pages/SearchDetailLogout5'
import SearchDetailLogout6 from '@/pages/SearchDetailLogout6'
import SearchDetailLogout2 from '@/pages/SearchDetailLogout2'
import SearchDetailWork6 from '@/pages/SearchDetailWork6'
import SearchDetailHouse8 from '@/pages/SearchDetailHouse8'
import SearchDetailHouse9 from '@/pages/SearchDetailHouse9'
import SearchDetailMarriage2 from '@/pages/SearchDetailMarriage2'
import SearchDetailCredit25 from '@/pages/SearchDetailCredit25'
import SearchDetailCredit23 from '@/pages/SearchDetailCredit23'
import SearchDetailEnterprise18 from '@/pages/SearchDetailEnterprise18'
import SearchDetailEnterprise19 from '@/pages/SearchDetailEnterprise19'
import SearchDetailEnterprise20 from '@/pages/SearchDetailEnterprise20'
import SearchDetailOperate26 from '@/pages/SearchDetailOperate26'
import SearchDetailOperate27 from '@/pages/SearchDetailOperate27'
import SearchDetailOperate28 from '@/pages/SearchDetailOperate28'
import SearchDetailOperate29 from '@/pages/SearchDetailOperate29'
import SearchDetailOperate30 from '@/pages/SearchDetailOperate30'
import SearchDetailOperate31 from '@/pages/SearchDetailOperate31'
import SearchDetailLogout7 from '@/pages/SearchDetailLogout7'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },{
      path: '/multiple',
      name: 'multiple',
      component: Multiple
    },{
      path: '/search',
      name: 'search',
      component: Search
    },{
      path: '/searchDetail',
      name: 'searchDetail',
      component: SearchDetail
    },{
      path: '/dawan',
      name: 'dawan',
      component: Dawan
    },{
      path: '/intelligent',
      name: 'intelligent',
      component: Intelligent
    }, {
      path: '/doclearance',
      name: 'doclearance',
      component: DoClearance
    }, {
      path: '/doclearancedetail',
      name: 'doclearancedetail',
      component: DoClearanceDetail
    }, {
      path: '/doinvest',
      name: 'doinvest',
      component: DoInvest
    }, {
      path: '/dowork',
      name: 'dowork',
      component: DoWork
    }, {
      path: '/doworkdetail',
      name: 'doworkdetail',
      component: DoWorkDetail
    }, {
      path: '/explain',
      name: 'explain',
      component: Explain
    }, {
      path: '/SearchDetailBorn1',
      name: 'SearchDetailBorn1',
      component: SearchDetailBorn1
    }, {
      path: '/SearchDetailBorn2',
      name: 'SearchDetailBorn2',
      component: SearchDetailBorn2
    }, {
      path: '/SearchDetailBorn3',
      name: 'SearchDetailBorn3',
      component: SearchDetailBorn3
    }, 
    {
      path: '/SearchDetailBorn4',
      name: 'SearchDetailBorn4',
      component: SearchDetailBorn4
    },  
    {
      path: '/SearchDetailStudy1',
      name: 'SearchDetailStudy1',
      component: SearchDetailStudy1
    }, {
      path: '/SearchDetailWork1',
      name: 'SearchDetailWork1',
      component: SearchDetailWork1
    },{
      path: '/SearchDetailWork2',
      name: 'SearchDetailWork2',
      component: SearchDetailWork2
    },{
      path: '/SearchDetailWork3',
      name: 'SearchDetailWork3',
      component: SearchDetailWork3
    },{
      path: '/SearchDetailWork4',
      name: 'SearchDetailWork4',
      component: SearchDetailWork4
    },{
      path: '/SearchDetailWork5',
      name: 'SearchDetailWork5',
      component: SearchDetailWork5 
    },{
      path: '/SearchDetailHouse1',
      name: 'SearchDetailHouse1',
      component: SearchDetailHouse1
    },{
      path: '/SearchDetailHouse2',
      name: 'SearchDetailHouse2',
      component: SearchDetailHouse2
    },
    {
      path: '/SearchDetailHouse3',
      name: 'SearchDetailHouse3',
      component: SearchDetailHouse3
    }, 
    {
      path: '/SearchDetailHouse4',
      name: 'SearchDetailHouse4',
      component: SearchDetailHouse4
    }, 
    {
      path: '/SearchDetailHouse5',
      name: 'SearchDetailHouse5',
      component: SearchDetailHouse5
    }, 
    {
      path: '/SearchDetailHouse6',
      name: 'SearchDetailHouse6',
      component: SearchDetailHouse6
    }, 
    {
      path: '/SearchDetailHouse7',
      name: 'SearchDetailHouse7',
      component: SearchDetailHouse7
    }, 
    
    {
      path: '/SearchDetailMarriage1',
      name: 'SearchDetailMarriage1',
      component: SearchDetailMarriage1
    },
    {
      path: '/SearchDetailCredit2',
      name: 'SearchDetailCredit2',
      component: SearchDetailCredit2
    },
    {
      path: '/SearchDetailCredit3',
      name: 'SearchDetailCredit3',
      component: SearchDetailCredit3
    },
    {
      path: '/SearchDetailCredit4',
      name: 'SearchDetailCredit4',
      component: SearchDetailCredit4
    },
    {
      path: '/SearchDetailCredit5',
      name: 'SearchDetailCredit5',
      component: SearchDetailCredit5
    },
    {
      path: '/SearchDetailCredit6',
      name: 'SearchDetailCredit6',
      component: SearchDetailCredit6
    },
    {
      path: '/SearchDetailCredit7',
      name: 'SearchDetailCredit7',
      component: SearchDetailCredit7
    },
    {
      path: '/SearchDetailCredit8',
      name: 'SearchDetailCredit8',
      component: SearchDetailCredit8
    },
    {
      path: '/SearchDetailCredit9',
      name: 'SearchDetailCredit9',
      component: SearchDetailCredit9
    },
    {
      path: '/SearchDetailCredit10',
      name: 'SearchDetailCredit10',
      component: SearchDetailCredit10
    },
    {
      path: '/SearchDetailCredit11',
      name: 'SearchDetailCredit11',
      component: SearchDetailCredit11
    },
    {
      path: '/SearchDetailCredit12',
      name: 'SearchDetailCredit12',
      component: SearchDetailCredit12
    },
    {
      path: '/SearchDetailCredit13',
      name: 'SearchDetailCredit13',
      component: SearchDetailCredit13
    },
    {
      path: '/SearchDetailCredit14',
      name: 'SearchDetailCredit14',
      component: SearchDetailCredit14
    },
    {
      path: '/SearchDetailCredit15',
      name: 'SearchDetailCredit15',
      component: SearchDetailCredit15
    },
    {
      path: '/SearchDetailCredit16',
      name: 'SearchDetailCredit16',
      component: SearchDetailCredit16
    },
    {
      path: '/SearchDetailCredit17',
      name: 'SearchDetailCredit17',
      component: SearchDetailCredit17
    },
    {
      path: '/SearchDetailCredit18',
      name: 'SearchDetailCredit18',
      component: SearchDetailCredit18
    },
    {
      path: '/SearchDetailCredit19',
      name: 'SearchDetailCredit19',
      component: SearchDetailCredit19
    },
    {
      path: '/SearchDetailCredit20',
      name: 'SearchDetailCredit20',
      component: SearchDetailCredit20
    },
    {
      path: '/SearchDetailCredit21',
      name: 'SearchDetailCredit21',
      component: SearchDetailCredit21
    },
    {
      path: '/SearchDetailCredit22',
      name: 'SearchDetailCredit22',
      component: SearchDetailCredit22
    },
     {
      path: '/SearchDetailRetirement1',
      name: 'SearchDetailRetirement1',
      component: SearchDetailRetirement1
    },
    {
      path: '/SearchDetailRetirement2',
      name: 'SearchDetailRetirement2',
      component: SearchDetailRetirement2
    },
    {
      path: '/SearchDetailRetirement3',
      name: 'SearchDetailRetirement3',
      component: SearchDetailRetirement3
    },
    {
      path: '/SearchDetailRetirement4',
      name: 'SearchDetailRetirement4',
      component: SearchDetailRetirement4
    },
     {
      path: '/SearchDetailDeath1',
      name: 'SearchDetailDeath1',
      component: SearchDetailDeath1
    }, {
      path: '/SearchDetailEnterprise1',
      name: 'SearchDetailEnterprise1',
      component: SearchDetailEnterprise1
    }, {
      path: '/SearchDetailEnterprise2',
      name: 'SearchDetailEnterprise2',
      component: SearchDetailEnterprise2
    },{
      path: '/SearchDetailEnterprise3',
      name: 'SearchDetailEnterprise3',
      component: SearchDetailEnterprise3
    },{
      path: '/SearchDetailEnterprise4',
      name: 'SearchDetailEnterprise4',
      component: SearchDetailEnterprise4
    },{
      path: '/SearchDetailEnterprise5',
      name: 'SearchDetailEnterprise5',
      component: SearchDetailEnterprise5
    },{
      path: '/SearchDetailRecruit2',
      name: 'SearchDetailRecruit2',
      component: SearchDetailRecruit2
    },{
      path: '/SearchDetailLogout3',
      name: 'SearchDetailLogout3',
      component: SearchDetailLogout3
    },{
      path: '/SearchDetailOperate8',
      name: 'SearchDetailOperate8',
      component: SearchDetailOperate8
    },{
      path: '/SearchDetailOperate3',
      name: 'SearchDetailOperate3',
      component: SearchDetailOperate3
    },{
      path: '/SearchDetailOperate4',
      name: 'SearchDetailOperate4',
      component: SearchDetailOperate4
    },{
      path: '/SearchDetailOperate11',
      name: 'SearchDetailOperate11',
      component: SearchDetailOperate11
    },{
      path: '/SearchDetailOperate12',
      name: 'SearchDetailOperate12',
      component: SearchDetailOperate12
    },{
      path: '/SearchDetailOperate1',
      name: 'SearchDetailOperate1',
      component: SearchDetailOperate1
    }, {
      path: '/SearchDetailOperate2',
      name: 'SearchDetailOperate2',
      component: SearchDetailOperate2
    }, {
      path: '/SearchDetailOperate5',
      name: 'SearchDetailOperate5',
      component: SearchDetailOperate5
    }, {
      path: '/SearchDetailOperate6',
      name: 'SearchDetailOperate6',
      component: SearchDetailOperate6
    }, {
      path: '/SearchDetailOperate7',
      name: 'SearchDetailOperate7',
      component: SearchDetailOperate7
    }, {
      path: '/SearchDetailOperate9',
      name: 'SearchDetailOperate9',
      component: SearchDetailOperate9
    }, {
      path: '/SearchDetailOperate10',
      name: 'SearchDetailOperate10',
      component: SearchDetailOperate10
    }, {
      path: '/SearchDetailOperate13',
      name: 'SearchDetailOperate13',
      component: SearchDetailOperate13
    }, {
      path: '/SearchDetailOperate14',
      name: 'SearchDetailOperate14',
      component: SearchDetailOperate14
    }, {
      path: '/SearchDetailOperate15',
      name: 'SearchDetailOperate15',
      component: SearchDetailOperate15
    },{
      path: '/SearchDetailOperate16',
      name: 'SearchDetailOperate16',
      component: SearchDetailOperate16
    }, {
      path: '/SearchDetailOperate17',
      name: 'SearchDetailOperate17',
      component: SearchDetailOperate17
    },{
      path: '/SearchDetailOperate18',
      name: 'SearchDetailOperate18',
      component: SearchDetailOperate18
    },
    {
      path: '/SearchDetailOperate19',
      name: 'SearchDetailOperate19',
      component: SearchDetailOperate19
    },
    {
      path: '/SearchDetailOperate20',
      name: 'SearchDetailOperate20',
      component: SearchDetailOperate20
    },
    {
      path: '/SearchDetailOperate21',
      name: 'SearchDetailOperate21',
      component: SearchDetailOperate21
    },
    {
      path: '/SearchDetailOperate22',
      name: 'SearchDetailOperate22',
      component: SearchDetailOperate22
    },
    {
      path: '/SearchDetailOperate23',
      name: 'SearchDetailOperate23',
      component: SearchDetailOperate23
    },
    {
      path: '/SearchDetailOperate24',
      name: 'SearchDetailOperate24',
      component: SearchDetailOperate24
    },
    {
      path: '/SearchDetailOperate25',
      name: 'SearchDetailOperate25',
      component: SearchDetailOperate25
    },
    {
      path: '/SearchDetailRecruit1',
      name: 'SearchDetailRecruit1',
      component: SearchDetailRecruit1
    }, {
      path: '/SearchDetailPay1',
      name: 'SearchDetailPay1',
      component: SearchDetailPay1
    }, {
      path: '/SearchDetailLogout1',
      name: 'SearchDetailLogout1',
      component: SearchDetailLogout1
    },
    {
      path: '/SearchDetailEnterprise6',
      name: 'SearchDetailEnterprise6',
      component: SearchDetailEnterprise6
    },
    {
      path: '/SearchDetailEnterprise7',
      name: 'SearchDetailEnterprise7',
      component: SearchDetailEnterprise7
    },
    {
      path: '/SearchDetailLogout4',
      name: 'SearchDetailLogout4',
      component: SearchDetailLogout4
    },
    {
      path: '/SearchDetailEnterprise8',
      name: 'SearchDetailEnterprise8',
      component: SearchDetailEnterprise8
    },
    {
      path: '/SearchDetailEnterprise9',
      name: 'SearchDetailEnterprise9',
      component: SearchDetailEnterprise9
    },
    {
      path: '/SearchDetailEnterprise10',
      name: 'SearchDetailEnterprise10',
      component: SearchDetailEnterprise10
    },
    {
      path: '/SearchDetailEnterprise11',
      name: 'SearchDetailEnterprise11',
      component: SearchDetailEnterprise11
    },
    {
      path: '/SearchDetailEnterprise12',
      name: 'SearchDetailEnterprise12',
      component: SearchDetailEnterprise12
    },
    {
      path: '/SearchDetailEnterprise13',
      name: 'SearchDetailEnterprise13',
      component: SearchDetailEnterprise13
    },
    {
      path: '/SearchDetailEnterprise14',
      name: 'SearchDetailEnterprise14',
      component: SearchDetailEnterprise14
    },
    {
      path: '/SearchDetailEnterprise15',
      name: 'SearchDetailEnterprise15',
      component: SearchDetailEnterprise15
    },   
    {
      path: '/SearchDetailEnterprise16',
      name: 'SearchDetailEnterprise16',
      component: SearchDetailEnterprise16
    },
    {
      path: '/SearchDetailEnterprise17',
      name: 'SearchDetailEnterprise17',
      component: SearchDetailEnterprise17
    },
    {
      path: '/SearchDetailLogout5',
      name: 'SearchDetailLogout5',
      component: SearchDetailLogout5
    },
    {
      path: '/SearchDetailLogout6',
      name: 'SearchDetailLogout6',
      component: SearchDetailLogout6
    },
    {
      path: '/SearchDetailLogout2',
      name: 'SearchDetailLogout2',
      component: SearchDetailLogout2
    },
    {
      path: '/SearchDetailWork6',
      name: 'SearchDetailWork6',
      component: SearchDetailWork6
    },
    {
      path: '/SearchDetailHouse8',
      name: 'SearchDetailHouse8',
      component: SearchDetailHouse8
    },
    {
      path: '/SearchDetailHouse9',
      name: 'SearchDetailHouse9',
      component: SearchDetailHouse9
    },
    {
      path: '/SearchDetailMarriage2',
      name: 'SearchDetailMarriage2',
      component: SearchDetailMarriage2
    },
    {
      path: '/SearchDetailCredit25',
      name: 'SearchDetailCredit25',
      component: SearchDetailCredit25
    },
    {
      path: '/SearchDetailCredit23',
      name: 'SearchDetailCredit23',
      component: SearchDetailCredit23
    },    
    {
      path: '/SearchDetailEnterprise18',
      name: 'SearchDetailEnterprise18',
      component: SearchDetailEnterprise18
    },    
    {
      path: '/SearchDetailEnterprise19',
      name: 'SearchDetailEnterprise19',
      component: SearchDetailEnterprise19
    },    
    {
      path: '/SearchDetailEnterprise20',
      name: 'SearchDetailEnterprise20',
      component: SearchDetailEnterprise20
    },    
    {
      path: '/SearchDetailOperate26',
      name: 'SearchDetailOperate26',
      component: SearchDetailOperate26
    },    
    {
      path: '/SearchDetailOperate27',
      name: 'SearchDetailOperate27',
      component: SearchDetailOperate27
    },    
    {
      path: '/SearchDetailOperate28',
      name: 'SearchDetailOperate28',
      component: SearchDetailOperate28
    },   
    {
      path: '/SearchDetailOperate29',
      name: 'SearchDetailOperate29',
      component: SearchDetailOperate29
    },    
    {
      path: '/SearchDetailOperate30',
      name: 'SearchDetailOperate30',
      component: SearchDetailOperate30
    },    
    {
      path: '/SearchDetailOperate31',
      name: 'SearchDetailOperate31',
      component: SearchDetailOperate31
    },    
    {
      path:'/SearchDetailLogout7',
      name:'SearchDetailLogout7',
      component: SearchDetailLogout7
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js